import style from "./StatusBadge.module.css";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

export type StatusBadgeProps = {
  type:
    | "requested"
    | "pending"
    | "processing"
    | "complete"
    | "unsuccessful"
    | "cancelled";
};

const StatusBadge = ({ type }: StatusBadgeProps) => {
  const { t } = useTranslation();

  const statusBadgeProps: { [index: string]: { label: string } } = {
    requested: {
      label: t("transactions.history.status.requested"),
    },
    pending: {
      label: t("transactions.history.status.pending"),
    },
    processing: {
      label: t("transactions.history.status.processing"),
    },
    complete: {
      label: t("transactions.history.status.complete"),
    },
    unsuccessful: {
      label: t("transactions.history.status.unsuccessful"),
    },
    cancelled: {
      label: t("transactions.history.status.cancelled"),
    },
  };

  return (
    <div className={clsx(style.wrapper, style[`wrapper-${type}`])}>
      <span>{statusBadgeProps[type].label}</span>
    </div>
  );
};

StatusBadge.displayName = "StatusBadge";

export default StatusBadge;
